export default String.raw`
const afterAddingToPopupUI = (() => {
    'use strict';
    const getRandomProductId = (products) => {
        if (!products || products.length === 0) {
            return null;
        }
        const randomIndex = Math.floor(Math.random() * products.length);
        return products[randomIndex].Id;
    };

    const getAIRecommendations = async (productId) => {
        const data = {
            __csrf: __CSRF,
            __collection: "product-presentation.Product.RelatedProducts.AIProductsRecommendations",
            __template: "partials/product/AI-recommended.html"
        }

        const url = '_/3-2-' + productId;

        try {
            const response = await $.get(url, data);
            
            if (!response?.template || response?.collection?.length === 0) {
                return null;
            }

            return response.template;
        } catch (error) {
            console.warn("Cannot get AI Recommendations for product.", error)
        }
    }

    // Function that maps products to proper DOM structure
    const mapProducts = (products) => {
        const mappedProducts = products.map(product => {
            let attributesDict = {};
            if (product.Attributes) {
                attributesDict = product.Attributes.split(';').reduce((dict, attr) => {
                    if (attr.trim()) {
                        const [key, value] = attr.split(':');
                        dict[key.trim()] = value.trim();
                    }
                    return dict;
                }, {});
            }
        
            let imageSrc;
            if (product?.Image?.Id >= 0) {
                imageSrc = product.Image.ExternalUrl || 'img/medium/' + product.Image.Id + '/' + product.Image.Link + '.jpg';
            } else {
                imageSrc = 'css/img/img-placeholder.jpg';
            }

            let productValue;
            if (__subtotalPrices == 'true') {
                productValue = product.SubtotalValue;
            } else {
                productValue = product.TotalValue;
            }

            let productUnits;
            if (product.BasicUnit == null) {
                productUnits = product.SaleUnit;
            } else {
                productUnits = product.BasicUnit;
            }

            return {
                Id: product.Id,
                Src: imageSrc,
                Alt: product.NameNoHtml,
                Name: product.NameNoHtml,
                Attributes: attributesDict,
                Value: productValue,
                Quantity: product.Quantity,
                BasicUnitQuantity: product.BasicUnitQuantity,
                SaleUnit: product.SaleUnit,
                BasicUnit: product.BasicUnit,
                Deposit: product.DepositValue,
                productUnits: productUnits
            };
		});

        return mappedProducts;
    };
    const getProductTemplate = (product) => {
        let attributesString = "";
        Object.keys(product.Attributes).forEach(key => {
            attributesString += '<p class="product__attribute"><span class="key">' + key + ': </span>' + '<span class="value">' + product.Attributes[key] + '</span></p>';
        });
        attributesString += '<p class="product__attribute product__attribute--quantity"><span class="key key--quantity">' + __translations.Quantity +': </span><span class="value value--quantity">' + product.Quantity + ' ' + product.SaleUnit + '</span></p>';
        
        let priceType;
        if (__subtotalPrices == 'true') {
            priceType = __translations.netto;
        } else {
            priceType = __translations.brutto;
        }

        let depositText = '';
        if (product?.Deposit) {
            depositText = '<span class="deposit">+ ' + __translations.Com_Deposit + ': ' + product?.Deposit?.toPrice() + ' ' + __curr + ' / ' + product.productUnits + '</span>';
        }

        return '<li class="products__list-item">' +
                        '<div class="product__image-wrapper">' +
                            '<img class="product__image" src="' + product.Src + '" alt="' + product.Alt + '">' +
                        '</div>' +
                        '<div class="product__details">' +
                            '<p class="product__name">' + product.Name + '</p>' +
                            '<div class="product__attributes">' + attributesString + '</div>' +
                        '</div>' +
                        '<p class="product__price">' + '<span class="value">' + product?.Value?.toPrice() + ' ' + __curr + '<span class="currency">' + priceType + '</span>' + '</span>' + depositText + '</p>' +
                    '</li>';
    };

    const redirectStartegy = () => {
        app.temporaryPopupMessage(undefined, __redirectInfo, 'msg');
        setTimeout(() => { window.location.href = __CartLink; }, 1000);
    };

    const stayAtCurrentPageStrategy = () => app.temporaryPopupMessage(undefined, __translations.AddedToCart, 'msg');

    const showCartPopupStartegy = async (products) => {
        const popup = document.querySelector('.after-adding-to-cart-popup-js');

        if (!popup) {
            return;
        }

        const items = mapProducts(products).map(getProductTemplate).join('');
        
        const isPopupOpen = popup.hasAttribute('open');
        if (isPopupOpen) {
            $('.after-adding-to-cart-popup-js .products-js').append(items);
            const currentCount = parseInt($('.after-adding-to-cart-count-js').attr('data-count')) || 0;
            const newCount = (products?.length || 0) + currentCount;
            $('.after-adding-to-cart-count-js').html('(' + newCount + ')').attr('data-count', newCount);;
        } else {
            $('.after-adding-to-cart-count-js').html('(' + (products?.length || 0) + ')').attr('data-count', products?.length || 0);
            $('.after-adding-to-cart-popup-js .products-js').html(items);
        }

        // AI Reccomendations for random product added to cart
        const AIRecommendations = document.querySelector('.ai-recommended-js');
        if (AIRecommendations) {
            const randomProductId = getRandomProductId(products);
            const AIRecommendationsTemplate = await getAIRecommendations(randomProductId);

            $('.ai-recommended-js').empty()
            if (AIRecommendationsTemplate) {
                $('.ai-recommended-js').html(AIRecommendationsTemplate);
            }
        }

        popup.showModal();
    };


    window.addEventListener("cart:added", (e) => {
		const products = e.detail.products;
		const template = e.detail.template;
        const strategy = e.detail.strategy || __aatc;

        const orderTemplate = document.querySelector('.order-template-js');
        if (orderTemplate) {
            const message = $('.add-to-cart-from-cart-js').data('message');
            $('.order-template-js .during-ajax-modal-js').addClass('hidden-js');
            app.temporaryPopupMessage(null, message, 'msg');

			setTimeout(() => {
				if (template && template.indexOf('cart-products-container-js') !== -1) {
					const obj = app.getTemplate(e.detail.event);
					app.afterReplaceTemplate(e.detail.event, obj, template);
					changeHeaderCart();
				}
			}, 1000);

            return;
        }

        switch (strategy) {
            case "1":
                redirectStartegy()
                break;
            case "2":
                stayAtCurrentPageStrategy()
                break;
            case "3":
                showCartPopupStartegy(products)
                break;
            default:
        }
    });

    window.addEventListener('inquiry:added', (e) => {
		const products = e.detail.products;
        const failure = e.detail.failure;

        if (failure) {
            app.temporaryPopupMessage(undefined, __translations.AddedToInquiry, 'msg')
            return;
        }

        const popup = document.querySelector('.after-adding-to-inquiry-popup-js');

        if (!popup) {
            return;
        }

        const items = mapProducts(products).map(getProductTemplate).join('');
        $('.after-adding-to-inquiry-count-js').html('(' + (products?.length || 0) + ')');
		$('.after-adding-to-inquiry-popup-js .products-js').html(items);
        
        popup.showModal();
    });

    window.addEventListener('wishlist:added', (e) => {
        const products = e.detail.products;
        const failure = e.detail.failure;

        if (failure) {
            app.temporaryPopupMessage(undefined, __translations.AddedToWishList, 'msg')
            return;
        }

        const popup = document.querySelector('.after-adding-to-wishlist-popup-js');

        if (!popup) {
            return;
        }

        const items = mapProducts(products).map(getProductTemplate).join('');
        $('.after-adding-to-wishlist-count-js').html('(' + (products?.length || 0) + ')');
        $('.after-adding-to-wishlist-popup-js .products-js').html(items);

        popup.showModal();
    });
})();
`